var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_apollo_client_link_core_ApolloLink_js"), __webpack_require__.e("webpack_sharing_consume_default_graphql_graphql"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("build_node_index_js")]).then(() => (() => ((__webpack_require__("./build/node/index.js")))));
	},
	"./testing": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_apollo_client_cache_inmemory_inMemoryCache_js-node_modules_apollo_client-f3658f"), __webpack_require__.e("vendors-node_modules_apollo_client_link_core_ApolloLink_js"), __webpack_require__.e("webpack_sharing_consume_default_graphql_graphql"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("build_node_testing_js")]).then(() => (() => ((__webpack_require__("./build/node/testing.js")))));
	},
	"./fixtures": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("build_node_fixtures_js")]).then(() => (() => ((__webpack_require__("./build/node/fixtures.js")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});